import { render } from "./westSoftAccountModel.vue?vue&type=template&id=26b22180"
import script from "./westSoftAccountModel.vue?vue&type=script&lang=js"
export * from "./westSoftAccountModel.vue?vue&type=script&lang=js"

import "./westSoftAccountModel.vue?vue&type=style&index=0&id=26b22180&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__